import React from 'react';
import classNames from 'classnames';
import styles from './tabs.module.css.js';

function Tabpanel({ children, tabId, className }) {
    return (React.createElement("div", { id: `${tabId}-tabpanel`, role: 'tabpanel', "aria-labelledby": tabId, className: classNames(styles.tabpanel, className) }, children));
}

export { Tabpanel as default };
